import React from 'react';
import Button from '../../../components/ui/Button';

const QuickDateSelector = ({ onSelectDate }) => {
  const getQuickDate = (daysFromNow) => {
    const date = new Date();
    date?.setDate(date?.getDate() + daysFromNow);
    return date;
  };

  const quickOptions = [
    { label: 'Today', days: 0 },
    { label: 'Tomorrow', days: 1 },
    { label: 'This Weekend', days: 5 },
    { label: 'Next Week', days: 7 }
  ];

  return (
    <div className="mb-6 md:mb-8">
      <h3 className="font-caption font-medium text-sm md:text-base text-foreground mb-3 md:mb-4">
        Quick Selection
      </h3>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-2 md:gap-3 lg:gap-4">
        {quickOptions?.map((option, index) => (
          <Button
            key={index}
            variant="outline"
            size="default"
            onClick={() => onSelectDate(getQuickDate(option?.days))}
            iconName="Calendar"
            iconPosition="left"
            className="w-full"
          >
            {option?.label}
          </Button>
        ))}
      </div>
    </div>
  );
};

export default QuickDateSelector;